import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";
import { FormFieldLabel, RangeSelectWithFilter } from "app/pages/sales-intelligence/common-components/form-fields";
import FilterClearButton from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/FilterClearButton";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { StyledNumberOfRatingContainer } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/components/NumberOfRatings/styles";
import { formatNumber } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/utils";
import { RANGE_SELECT_WIDTH } from "app/pages/sales-intelligence/modules/find-apps-filters/constants";
import type FindAppsRatingFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/RatingFilter";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

export const NumberOfRatings: FC<IFilterViewBaseProps<FindAppsRatingFilter>> = ({ filter, onFilterUpdate, value }) => {
    const handleChange = ([minValue, maxValue]: Array<number | undefined>) => {
        onFilterUpdate({ ...value, numberOfRatings: { from: minValue, to: maxValue } });
    };

    const handleClear = () => {
        onFilterUpdate(value?.score ? { score: value.score } : undefined);
    };

    const isValueSet = !is.undefined(value?.numberOfRatings?.from) || !is.undefined(value?.numberOfRatings?.to);

    return (
        <StyledNumberOfRatingContainer>
            <FormFieldLabel text={translate("si.find_apps.filters.rating.number_of_ratings.heading")}>
                <RangeSelectWithFilter
                    fieldName="rating"
                    value={[value?.numberOfRatings?.from, value?.numberOfRatings?.to]}
                    optionsMin={filter.minOptions}
                    optionsMax={filter.maxOptions}
                    placeholderMin={translate("si.find_apps.filters.range.min.placeholder")}
                    placeholderMax={translate("si.find_apps.filters.range.max.placeholder")}
                    formatValue={formatNumber}
                    onChange={handleChange}
                    width={RANGE_SELECT_WIDTH}
                >
                    <FilterClearButton
                        onClick={handleClear}
                        isDisabled={!isValueSet}
                    />
                </RangeSelectWithFilter>
            </FormFieldLabel>
        </StyledNumberOfRatingContainer>
    );
};
